// A17.08/09 background-job monitor — module-local data layer. REAL backend
// (/admin/job-runs). Fed by the daily-maintenance worker (expire JIT grants /
// release expired holds) — real background activity, read-only.
import { api } from '@/lib/api'

export interface JobRun {
  id: number
  job_name: string
  status: string // ok|error
  detail: string
  items_affected: number
  duration_ms: number
  ran_at: string
}
export interface JobSummary {
  job_name: string
  runs: number
  errors: number
  last_run: string
  last_status: string
}

const opt = (s?: AbortSignal) => (s ? { signal: s } : undefined)

export const fetchRuns = (status = '', s?: AbortSignal) =>
  api.get<{ runs: JobRun[] }>('/admin/job-runs', { query: status ? { status } : {}, ...(s ? { signal: s } : {}) }).then((d) => d.runs ?? [])
export const fetchSummary = (s?: AbortSignal) =>
  api.get<{ jobs: JobSummary[] }>('/admin/job-runs/summary', opt(s)).then((d) => d.jobs ?? [])

export const JM_STR = {
  title: 'Фоновые задачи (cron)',
  desc: 'Запуски запланированных воркеров + ежедневное обслуживание (реальная активность)',
  jobs: 'Задачи',
  recent: 'Последние запуски',
  runs: 'запусков',
  errors: 'ошибок',
  lastRun: 'Последний',
  items: 'изменено',
  ok: 'OK',
  error: 'Ошибка',
  empty: 'Нет запусков (воркер запускается раз в сутки)',
  all: 'Все',
  refresh: 'Обновить',
} as const

// Human-readable job names.
export const JOB_LABEL: Record<string, string> = {
  expire_jit_grants: 'Истечение JIT-грантов',
  release_expired_holds: 'Снятие истёкших legal-hold',
  fraud_multi_account: 'Анти-фрод: мульти-аккаунты',
  fraud_transfer_fanout: 'Анти-фрод: веерные переводы',
  fraud_otp_burst: 'Анти-фрод: всплеск OTP',
  fraud_dm_spam: 'Анти-фрод: DM-спам',
  points_gift_abuse: 'Баллы: злоупотребление подарками',
  referral_abuse: 'Рефералы: фрод',
  content_moderation_scan: 'Авто-модерация: скан',
}
export function jobLabel(n: string) {
  return JOB_LABEL[n] ?? n
}
